import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import {
    DataSnapshot,
    onValue,
    ref,
    set,
    Unsubscribe
} from 'firebase/database';
import { observable } from 'mobx';

export class BaseFirebaseStore {
    private unsubList: Unsubscribe[] = [];

    constructor() {}

    protected listenOnPath(
        path: string,
        onData: (data: any, snapshot: DataSnapshot) => void
    ) {
        const fb = getFirebase();
        const onUnsub = onValue(
            ref(fb.db, path),
            snapshot => {
                const data = snapshot.val();
                onData(data, snapshot);
            },
            error => {
                console.error('Error fetching data: ', path, error);
            }
        );
        this.unsubList.push(onUnsub);
    }

    unregister() {
        for (let fn of this.unsubList) {
            fn();
        }

        this.unsubList = [];
    }
}
